import { useEffect } from 'react';
import { Button, FlexboxGrid, List, Modal } from 'rsuite';
import './ActionConfirm.less';

interface IProps {
  open: boolean;
  setOpen: any;
  displayOpts: Record<string, any>[];
  title: string;
  subTitle?: string;
  onConfirm?: any;
  onClose?: any;
  size?: string;
  isCloseBtn?: boolean;
}
export const ActionConfirm = ({
  open,
  setOpen,
  displayOpts,
  title,
  subTitle,
  onConfirm,
  onClose,
  isCloseBtn,
  size
}: IProps) => {
  const handleClose = () => {
    setOpen(false);
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };
  const handleConfirm = () => {
    if (onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
  };
  useEffect(() => {
    console.log('displayOpts', displayOpts);
  }, [displayOpts]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      size={size || 'md'}
      className="action-confirm"
    >
      <Modal.Header>
        {/* <Modal.Title style={{ color: '#01598f' }}>{title}</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <div className="content-confirm">
          <h6 style={{ paddingBottom: '30px' }}>{title}</h6>
          <ul>
            {displayOpts?.map((obj: Record<string, any>, index: number) => {
              return (
                <li key={index}>
                  <FlexboxGrid>
                    {/*icon*/}
                    <FlexboxGrid.Item colspan={6}>{obj?.name}</FlexboxGrid.Item>
                    <FlexboxGrid.Item
                      colspan={16}
                      style={{ fontWeight: 'bold' }}
                    >
                      {obj?.format ? obj.format(obj?.value) : obj?.value}
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </li>
              );
            })}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {isCloseBtn ? (
          <Button onClick={handleClose} appearance="ghost">
            Close
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} appearance="ghost">
              Cancel
            </Button>
            <Button onClick={handleConfirm} appearance="primary">
              Confirm
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};
